require('./').polyfill()



/*****************
 ** WEBPACK FOOTER
 ** ./~/raf/polyfill.js
 ** module id = 978
 ** module chunks = 0
 **/